/*
    © 2021 EcomGraduates.com. All rights reserved.
    https://www.ecomgraduates.com
*/

import { initWishlist } from './wishlist.js'

// Load Collection Contents via ajax
const loadCollectionContents = async (url = window.location.href) => {
    const $productList = document.querySelector('#collection-main-col .product-list')
    if ($productList) { $productList.style.opacity = 0.25 }

    const response = await fetch(url)
    const data = await response.text()

    const parser = new DOMParser()
    const newDocument = parser.parseFromString(data, 'text/html')

    document.querySelector('#collection-cols').replaceWith(newDocument.querySelector('#collection-cols'))
    // document.querySelector('#collection-utilities').replaceWith(newDocument.querySelector('#collection-utilities'))
    document.querySelector('#offcanvas-collection-filters-form').replaceWith(newDocument.querySelector('#offcanvas-collection-filters-form'))
    document.querySelector('#offcanvas-collections-filters-footer').replaceWith(newDocument.querySelector('#offcanvas-collections-filters-footer'))

    handleCollectionFiltersForm()
    initAjaxinate()
    fixCollectionSidebarStickyPos()
    initWishlist()

    window.history.replaceState({}, '', url)
    window.scrollTo({ top: 0, behavior: 'smooth' })
}

// Collection sort by
window.onChangeSortBy = (value) => {
    const params = new URLSearchParams(window.location.search)
    params.set('sort_by', value)
    const url = `${window.location.pathname}?${params.toString()}`

    loadCollectionContents(url)
}

// Collection filters form
const handleCollectionFiltersForm = () => {
    document.querySelectorAll('.collection-filter').forEach(($filter) => {
        $filter.addEventListener('change', () => {
            const $form = $filter.closest('form')
            const params = new URLSearchParams(new FormData($form))
            const url = `${window.location.pathname}?${params.toString()}`

            loadCollectionContents(url)
        })
    })
}
handleCollectionFiltersForm()

// Clear Collection Filters
window.clearCollectionFilters = () => {
    document.querySelectorAll('.collection-filters-form').forEach(($form) => {
        $form.style.opacity = 0.25
    })

    const params = new URLSearchParams(window.location.search)

    for (const [key] of Array.from(params)) {
        if (key !== 'sort_by') {
            params.delete(key)
        }
    }
    const url = `${window.location.pathname}?${params.toString()}`

    loadCollectionContents(url)
}

// Collection Infinite Scrolling (Ajaxinate)
const initAjaxinate = () => {
    if (document.querySelector('#AjaxinatePagination')) {
        // eslint-disable-next-line no-unused-vars
        const ajaxinate = new Ajaxinate({
            pagination: '#AjaxinatePagination',
            container: '#AjaxinateContainer',
            method: 'click',
            loadingText: 'Loading...',
            callback: () => {
                initWishlist()
            }
        })
    }
}
initAjaxinate()

// Fix sticky position for sidebar
const fixCollectionSidebarStickyPos = () => {
    const el = document.querySelector('#collection-sticky-sidebar .sticky-top')
    if (el) {
        const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top')?.clientHeight || 0
        el.style.top = `${navbarHeight + 25}px`
        el.style.zIndex = '1019'
    }
}
fixCollectionSidebarStickyPos()
